<template>
	<div class="app-card-subtitle">
		<span>€</span>
		<span v-if="subtitle !== undefined">{{
			formatNumericWhole(subtitle)
		}}</span>
	</div>
</template>

<script setup lang="ts">
import { formatNumericWhole } from "@/helpers/inputHelpers";

defineProps<{
	subtitle?: string | number;
}>();
</script>

<style lang="scss">
.app-card-subtitle {
	width: 200px;
	padding: 6px 7px 6px 12px;
	display: flex;
	justify-content: space-between;

	&.result {
		border-radius: var(--border-radius);

		&.neutral {
			background: var(--hover-muted);
			color: var(--text-primary);
		}

		&.success {
			background: var(--color-success);
			color: var(--text-invert);
		}

		&.failure {
			background: var(--color-fail);
			color: var(--text-invert);
		}
	}
}
</style>
